import React from "react";
import {
  Grid,
  Box,
  makeStyles,
  Hidden,
  useMediaQuery,
  useTheme,
  Divider,
  Container,
} from "@material-ui/core";
import FavIcon from "../../assets/images/favicon.png";
import mIamge from "../../assets/images/mImage.jpg";
import goa from "../../assets/images/goa1.jpg";
import FlightBooking from "../../assets/images/FlightBooking.jpg";
import MSearch from "../../form/MSearch";
import Footer from "./Footer";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SearchFlight from "../../form/SearchFlight";
import MSearchFlight from "../../form/MSearch";
import Carousel from "../../components/reusableComponents/Carousels";
import CarouselBottom from "../../components/reusableComponents/CarouselBottom";
import CarouselInterHoliday from "../../components/reusableComponents/CarouselInterHoliday";
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    paddingRight: 15,
    paddingLeft: 15,
    marginRight: "auto",
    marginLeft: "auto",
  },
  header: {
    background: "#fff",
    boxShadow: "0px 0px 10px rgb(0 0 0 / 5%)",
  },
  back: {
    backgroundImage: `url(${mIamge})`,

    // backgroundPosition: '1px -241px',
    zIndex: 0,
    backgroundAttachment: "fixed",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    transition: "background-image 300ms ease-in 200ms",
  },
}));
const MHome = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Box
        className={classes.container}
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box style={{ paddingBottom: 4.5, paddingTop: 4.5 }}>
          <i class="fas fa-blender-phone"></i>
          <span style={{ color: "#065999", fontSize: 13 }}>1800 8890 743 </span>
          <span style={{ display: "inline-block", width: "1px" }}></span>
          <i class="fa fa-fw fa-envelope"></i>
          <span style={{ color: "#065999", fontSize: 13 }}>info@xyz.com</span>
        </Box>
        <Box
          style={{ paddingBottom: 4.5, paddingTop: 4.5, alignItems: "center" }}
        >
          <i class="fa fa-fw fa-user"></i>
          <span style={{ color: "#065999", fontSize: 16 }}>Login</span>
        </Box>
      </Box>
      <header
        className={classes.header}
        style={{ paddingLeft: 20, paddingRight: 20 }}
      >
        <Hidden only={["xs"]}>
          {" "}
          <Box
            className={classes.container}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box display="flex" alignItems="center">
              <img
                src="https://www.marinersforex.com/img/LOGO-MarinersForex.png"
                style={{ height: 50 }}
              />
            </Box>
            <Box>
              <i
                class="fas fa-plane-departure"
                style={{ color: "blue", marginRight: 5 }}
              ></i>
              <span style={{ color: "#0A95FF" }}>Flight</span>
              <span style={{ color: "#0A95FF", marginLeft: 20 }}>
                My Booking
              </span>
            </Box>
          </Box>
        </Hidden>

        <Hidden only={["lg", "xl", "sm", "md"]}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <img
              src="https://www.marinersforex.com/img/LOGO-MarinersForex.png"
              style={{ height: 50 }}
            />
            <div className="icons">
              <div
                className="fas fa-bars"
                id="menu-btn"
                onClick={() => {
                  // let navbar = document.querySelector('.navbar');
                  // navbar.classList.toggle('active');
                  // navbar.classList.add('active');
                }}
              ></div>
            </div>
          </Box>
        </Hidden>
      </header>
      {/* <div
					style={{
						position: 'absolute',
						// top: '0px',
						left: '0px',
						height: '100%',
						width: '100%',
						zIndex: 1,
						background: 'rgb(26, 43, 72)',
						opacity: 0.3,
					}}></div> */}

      <div style={{ position: "relative" }}>
        {/* <div
					style={{
						position: 'absolute',
						top: '0px',
						left: '0px',
						height: '100%',
						width: '100%',
						zIndex: 1,
						background: 'rgb(26, 43, 72)',
						opacity: 0.3,
					}}></div> */}
        <section
          onClick={() => {
            // let loginForm = document.querySelector('.login-form');
            // let navbar = document.querySelector('.navbar');
            // navbar.classList.remove('active');
            // loginForm.classList.remove('active');
          }}
          className={classes.back}
          style={{ height: matches ? 800 : 500 }}
          // data-aos='zoom-in'
        >
          {/* <MSearch /> */}
          {/* <SearchFlight/> */}
          <MSearchFlight />
          <Box display='flex'>
						<div style={{ marginTop: 10, background: '#263a4a' }}>
							<p
								style={{
									color: 'red',
									fontSize: 16,
									fontWeight: 600,
									marginLeft: 5,
								}}>
								HotDeals
							</p>
						</div>
						<marquee>
							<div style={{ marginTop: 10, background: '#263a4a' }}>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
								<span style={{ marginLeft: 10, color: 'white' }}>
									E SINGAPORE AIRLINE @4200
								</span>
								<span style={{ marginLeft: 10, color: 'white' }}>|</span>
							</div>
						</marquee>
					</Box>
        </section>
      </div>
      <Box style={{ padding: 20 }}>
        <h2 style={{color: '#0c2f54',
    fontFamily: '"Poppins", sans-serif'}}>Search & Book Hotels</h2>
        <span style={{fontFamily: '"Poppins", sans-serif',fontSize:16}}>Enjoy unforgettable experiences in dream hotels worldwide</span>
       <div style={{marginTop:10}}>
	   <Carousel />
	   </div>
      </Box>
      <Grid
        container
        spacing={2}
        style={{ marginTop: matches ? 120 : 50, padding: 20 }}
      >
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <Box>
            <Box
              style={{
                position: "relative",
                background: "#e0fff5",
                margin: matches ? 0 : "50px 0px 50px 0px",
                padding: 20,
                borderRadius: 5,
                border: "1px solid rgba(0,0,0,.125)",
              }}
            >
              <h2
                style={{
                  color: "#0c2f54",
                  fontFamily: '"Poppins", sans-serif',
                }}
              >
                Domestic Holidays
              </h2>
              <p>
                Trips to India diverse tourist spots, redefine a new dimension
                of luxury and relaxation
              </p>
            </Box>
          </Box>
        </Grid>
        {[0, 1, 2].map((item) => {
          return (
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Box
                style={{
                  borderRadius: 5,
                  border: "1px solid rgba(0,0,0,.125)",
                }}
              >
                <img src={goa} style={{ height: 200, width: "100%" }} />
                <Box style={{ padding: 10 }}>
                  <p
                    style={{ color: "#343a40", fontWeight: 600, marginTop: 10 }}
                  >
                    Exotic Shimla Manali
                  </p>
                  <p style={{ color: "#6c757d" }}>Starting From ₹18500</p>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>

      <div style={{ padding: 20 }}>
        <h2
          style={{
            color: "#0c2f54",
            fontWeight: 600,
            fontFamily: '"Poppins", sans-serif',
          }}
        >
          Featured Deals
        </h2>
        <p style={{ color: "#0c2f54" }}>Get the Best Deals & Discounts</p>
      </div>
      <Grid container spacing={2} style={{ padding: 20 }}>
        <Grid item xs={12} sm={6} lg={6}>
          <img src={FlightBooking} style={{ width: "100%" }}></img>
        </Grid>
        <Grid item xs={12} sm={6} lg={6}>
          <img src={FlightBooking} style={{ width: "100%" }}></img>
        </Grid>
      </Grid>
      <div
        style={{
          padding: 20,
          boxShadow: "0px 0px 50px -35px rgb(0 0 0 / 40%)",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontWeight: 600,
            color: "#0c2f54",
            fontFamily: '"Poppins", sans-serif',
          }}
        >
          Start your travel planning here
        </h1>
        <Container style={{ marginTop: 20 }}>
          <Grid container spacing={2}>
            {[0, 1, 2, 3, 4, 5].map((i) => {
              return (
                <Grid item xs={12} lg={4} alignItems="center">
                  <Box justifyContent="space-between" display="flex">
                    <Box>
                      <h3>Delhi</h3>
                      <span>
                        <a>Mumbai</a>
                        <a style={{ marginLeft: 5 }}>Bangalore</a>
                        <a style={{ marginLeft: 5 }}>Kolkata</a>
                        <a style={{ marginLeft: 5 }}>Chandigarh</a>
                      </span>
                    </Box>
                    <ExpandMoreIcon />
                  </Box>
                  <Divider style={{ marginTop: 10 }} />
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </div>

      <Container>
        <img
          src="https://www.marinersforex.com/img/Rassia-MF.jpg"
          style={{ width: "100%" }}
        ></img>
        <h2 style={{ fontFamily: '"Poppins", sans-serif', color: "#0c2f54" }}>
          International Holidays
        </h2>
        <p>
          Explore a variety of holiday tour packages and create lasting memories
        </p>
        <CarouselInterHoliday />
      </Container>
      <Container>
        <img
          src="https://www.marinersforex.com/img/about.png"
          style={{ width: "100%" }}
        ></img>
      </Container>
      <Container>
	  <h1
          style={{
            textAlign: "center",
            fontWeight: 600,
            color: "#0c2f54",
            fontFamily: '"Poppins", sans-serif',
          }}
        >
          Travel Blog
        </h1>
		<p style={{
            textAlign: "center",
            fontWeight: 600,
            color: "#0c2f54",
            fontFamily: '"Poppins", sans-serif',
          }}>Explore these places and some other thing here</p>
        <CarouselBottom />
      </Container>
      {/* <Grid container  style={{ padding: 20 }}>
				<Grid item xs={4}></Grid>
				<Grid item xs={4}></Grid>
				<Grid item xs={4}></Grid>
			</Grid> */}
      <Footer />
    </>
  );
};

export default MHome;
